<template>
  <b-modal
      title="تأیید حذف"
      id="modal-delete"
      ok-title="حذف قطعی"
      ok-variant="danger"
      cancel-title="لغو"
      @ok="$emit('confirm')"
  >
    <p>آیا از حذف این فایل اطمینان دارید؟ این عمل غیرقابل بازگشت است.</p>
    <p class="text-muted">همه نسخه‌ها و ارتباطات این فایل نیز حذف خواهند شد.</p>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  name: 'DeleteConfirmModal',
  components: { BModal },

}
</script>
